import { ProjectBinderFolder } from '@/features/iata-binder/ProjectBinderFolder/ProjectBinderFolder';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/iata-binder/projects/$projectId/folders/$folderLetter/',
)({
    component: IataBinderFolderPage,
});

function IataBinderFolderPage() {
    return <ProjectBinderFolder />;
}
